import React from 'react';
import { styled } from '@this/constants/themes';
import _ from 'lodash';

import Transit from '@this/domain/transit/transit2';
import type Flight from '@this/domain/flight/flight2';
import type Hotel from '@this/domain/hotel/hotel2';

type Props = {
  elementType: 'transport' | 'hotel' | 'flight' | undefined;
  element: Transit | Hotel | Flight;
};

const ReserveConfirmOutlineItemShortdistanceTemplate: React.FC<Props> = ({ elementType, element }) => {
  return (
    <ReserveConfirmRightSection>
      {elementType === 'transport' && element instanceof Transit && (
        <>
          {element.legsummariesFromtoBefore && element.legsummariesTypepriceBefore && (
            <>
              <ReserveConfirmRightTitle>
                <p>{element.reserveConfirmElementLabelByTypeBefore}</p>
                <p>
                  <span data-wovn-ignore>
                    {element.legsummariesTypepriceBefore?.price &&
                      utils.digits(element.legsummariesTypepriceBefore.price)}
                  </span>
                  円
                </p>
              </ReserveConfirmRightTitle>
              <ReserveConfirmRightTitle>{element.legsummariesFromtoBefore}</ReserveConfirmRightTitle>
            </>
          )}
          {element.legsummariesFromtoAfter && element.legsummariesTypepriceAfter && (
            <>
              <ReserveConfirmRightTitle>
                <p>{element.reserveConfirmElementLabelByTypeAfter}</p>
                <p>
                  <span data-wovn-ignore>
                    {element.legsummariesTypepriceAfter?.price &&
                      utils.digits(element.legsummariesTypepriceAfter.price)}
                  </span>
                  円
                </p>
              </ReserveConfirmRightTitle>
              <ReserveConfirmRightTitle>{element.legsummariesFromtoAfter}</ReserveConfirmRightTitle>
            </>
          )}
        </>
      )}
    </ReserveConfirmRightSection>
  );
};

const ReserveConfirmRightSection = styled.div`
  margin-bottom: 15px;
`;

const ReserveConfirmRightTitle = styled.div`
  font-weight: bold;
  color: #959595;
  padding: 10px 10px 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default ReserveConfirmOutlineItemShortdistanceTemplate;
